import SearchSelect from "@/components/Filters/SearchSelect";
import NameFilter from "@/components/Filters/NameFilter";
import ColorFilter from "@/components/Filters/ColorFilter";
import { useDisclosure, Spinner, Button, Link, Image } from "@heroui/react";
import {
  IconCards,
  IconLayoutSidebar,
  IconMaximize,
  IconDotsVertical,
} from "@tabler/icons-react";
import AdvancedFiltersModal from "@/components/DeckBuilder/Mobile/AdvancedFiltersModal";
import { CDN } from "@/lib/cdn";

export default function Filters({
  filters,
  setFilter,
  clearAllFilters,
  deckCardsMap,
  searchDisplay,
  setSearchDisplay,
}: {
  filters: any;
  setFilter: any;
  clearAllFilters: any;
  deckCardsMap: any;
  searchDisplay: any;
  setSearchDisplay: any;
}) {
  const filtersModal = useDisclosure();
  const onReset = () => {
    console.log("reset");
    clearAllFilters();
  };

  return (
    <div className="flex flex-row p-2 items-center justify-center">
      <div className="w-[60px] h-[60px] mt-2 mr-2 flex items-center justify-center">
        <Link href="/">
          <Image
            src={`${CDN}/shared/logo/gumgum.png`}
            alt="gumgum.gg OPTCG fan site"
            width={60}
            height={60}
            className="object-contain w-full h-full"
            onError={() => console.error("Image failed to load")}
          />
        </Link>
      </div>
      <div className="flex flex-row flex-wrap items-center gap-2">
        <div className="flex flex-row">
          <SearchSelect
            selected={filters.searchSelect}
            setSelected={(val: any) => setFilter("searchSelect", val)}
          />
          <NameFilter
            selected={searchDisplay}
            setSelected={setSearchDisplay}
            placeholder={"Search"}
            rounded="rounded-l-none"
          />
        </div>
        <ColorFilter
          selected={filters.color}
          setSelected={(val: any) => setFilter("color", val)}
        />
        <Button
          isIconOnly
          size="sm"
          className={"h-[30px]"}
          aria-label="Like"
          onPress={() => {
            filtersModal.onOpen();
          }}
        >
          <IconDotsVertical size={20} />
        </Button>
        {/* <FiltersMobileModal /> */}
        <Button
          onPress={() => {
            clearAllFilters();
          }}
          radius="sm"
          className="h-[30px]"
        >
          Clear
        </Button>
      </div>
      <AdvancedFiltersModal
        filters={filters}
        setFilter={setFilter}
        clearAllFilters={clearAllFilters}
        isOpen={filtersModal.isOpen}
        onClose={filtersModal.onClose}
        onReset={onReset}
        searchDisplay={searchDisplay}
        setSearchDisplay={setSearchDisplay}
        deckCardsMap={deckCardsMap}
      />
    </div>
  );
}
